import React, { Component } from "react";
const imageLogo = require("../inter-assets/images/chausn-logo.png")
export class Navigation extends Component {
  render() {
    return (
      <nav id="menu" className="navbar navbar-default navbar-fixed-top">
        <div className="container">
          <div className="navbar-header">
            <button
              type="button"
              className="navbar-toggle collapsed"
              data-toggle="collapse"
              data-target="#bs-example-navbar-collapse-1"
            >
              {" "}
              <span className="sr-only">Toggle navigation</span>{" "}
              <span className="icon-bar"></span>{" "}
              <span className="icon-bar"></span>{" "}
              <span className="icon-bar"></span>{" "}
            </button>
            <img style={{ width: 140, textAlign: 'center', marginBottom: 10 }} src={imageLogo} alt="logo"></img>
            {/* <a className="navbar-brand page-scroll" href="#page-top">
              React Landing Page
            </a>{" "} */}
          </div>

          <div
            className="collapse navbar-collapse"
            id="bs-example-navbar-collapse-1"
          >
            <ul className="nav navbar-nav navbar-right">
              <li>
                <a href="#features" className="page-scroll">
                  Tính năng
                </a>
              </li>
              <li>
                <a href="#about" className="page-scroll">
                  Về Chúng Tôi
                </a>
              </li>
              {/* <li>
                <a href="#services" className="page-scroll">
                  Services
                </a>
              </li> */}
              <li>
                <a href="#portfolio" className="page-scroll">
                  Bộ Sưu Tập
                </a>
              </li>
              <li>
                <a href="#testimonials" className="page-scroll">
                  Ý Kiến Khách Hàng
                </a>
              </li>
              {/* <li>
                <a href="#team" className="page-scroll">
                  Team
                </a>
              </li> */}
              <li>
                <a href="#contact" className="page-scroll">
                  Liên Hệ
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}

export default Navigation;
